module.exports = __webpack_public_path__ + "static/media/survey-1.c89727ef.png";